'use client';
import { Toaster } from 'sonner';
import { useTheme } from '@/context/ThemeContext';

export default function ToastProvider() {
  const { isDark } = useTheme();

  return (
    <Toaster
      position="bottom-right"
      theme={isDark ? 'dark' : 'light'}
      toastOptions={{
        style: {
          backgroundColor: 'var(--bg-card)',
          border: '1px solid var(--border-bright)',
          color: 'var(--text-primary)',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '13px',
        },
      }}
    />
  );
}